/**
 * SortEpisodesCtrl controller
 * Add/Edit Season TV Shows
 */

/**
 * SortEpisodesCtrl controller
 *
 * @class SortEpisodesCtrl
 * @memberof mwApp/seasons
 * @see mwApp/seasons
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/seasons.controller:SortEpisodesCtrl
 */
/* @ngInject */
export default function SortEpisodesCtrl ($uibModalInstance, $http, episodes, seasonId, tvShowId) {
  const vm = this
  vm.episodes = angular.copy(episodes)

  vm.sortEpisodes = 'Original'
  vm.sortedEpisodes = function (type) {
    switch (type) {
      case 'Original':
        vm.episodes = angular.copy(episodes)
        break
      case 'ASC':
        vm.episodes = vm.episodes.sort((a, b) => a.displayNumber - b.displayNumber)
        break
      case 'DESC':
        vm.episodes = vm.episodes.sort((a, b) => b.displayNumber - a.displayNumber)
        break
    }
  }

  vm.submit = function () {
    if (vm.sortEpisodes === 'Original') {
      $uibModalInstance.close(vm.episodes)
    } else {
      const url = 'api/episodes/sort'
      const params = {
        tvShowId,
        direction: vm.sortEpisodes
      }
      if (seasonId) {
        params.seasonId = seasonId
      }
      $http.patch(url, params)
        .then(() => {
        })
        .finally(() => {
          $uibModalInstance.close(vm.episodes)
        })
    }
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss(vm.episodes)
  }
}
